import { useLocation } from "react-router-dom";
import { Check } from "lucide-react";
import { ProjectAdvies } from "../components/sections/ProjectAdvies";
import { PhoneLink, WhatsAppButton } from "../components/home/CtaButtons";
import { useSEO } from "../lib/seo";
import { usePageSeo } from "../lib/siteTexts";
import { pageFaqJsonLd, useFaqs } from "../lib/faqs";
import { ProductFAQ } from "../components/product/ProductFAQ";

const NEXT = [
  "Wij bekijken uw aanvraag en eventuele foto's.",
  "U ontvangt een persoonlijke prijsindicatie.",
  "Wilt u verder? Dan meten we gratis bij u thuis in.",
];

export default function OfferteAanvragen() {
  const { search, state } = useLocation();
  const faqs = useFaqs("/offerte-aanvragen");
  const seo = usePageSeo("offerte");
  useSEO({
    title: seo.title,
    description: seo.description,
    path: "/offerte-aanvragen",
    faqJsonLd: pageFaqJsonLd(faqs, "/offerte-aanvragen"),
  });
  return (
    <>
    <section className="bg-slate-50" data-testid="offerte-page">
      <div className="container-tight grid gap-10 py-10 sm:py-14 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-8">
          <p className="eyebrow">5 korte stappen · Vrijblijvend</p>
          <h1 className="mt-3 font-display text-[clamp(1.75rem,2.2vw+1rem,2.6rem)] font-bold leading-tight text-ink">Ontvang vrijblijvend een prijsindicatie</h1>
          <p className="lead mt-4 max-w-2xl">Beantwoord een paar korte vragen over uw woning. Alleen uw naam, e-mailadres en telefoonnummer zijn verplicht; foto's en maten helpen ons, maar zijn niet nodig.</p>
          <div className="mt-8"><ProjectAdvies key={search} bronPagina={state?.from || "/offerte-aanvragen"} /></div>
        </div>
        <aside className="space-y-5 lg:col-span-4 lg:pt-24">
          <div className="card p-6">
            <h2 className="text-[17px] font-semibold text-ink">Wat gebeurt er hierna?</h2>
            <ol className="mt-4 space-y-3">
              {NEXT.map((t, i) => (
                <li key={t} className="flex gap-3 text-[14.5px] text-slate-600">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-maas-soft text-[12px] font-bold text-maas">{i + 1}</span>{t}
                </li>
              ))}
            </ol>
            <p className="mt-5 flex items-center gap-2 text-[13.5px] text-slate-500"><Check className="h-4 w-4 text-maas" aria-hidden="true" /> U zit nergens aan vast.</p>
          </div>
          <div className="card p-6">
            <h2 className="text-[17px] font-semibold text-ink">Liever direct contact?</h2>
            <p className="mt-2 text-[14.5px] text-slate-600">Stuur een foto van uw situatie via WhatsApp of bel ons tijdens kantooruren.</p>
            <div className="mt-4 flex flex-col items-start gap-3">
              <WhatsAppButton location="offerte-aside" className="w-full" />
              <PhoneLink location="offerte-aside" />
            </div>
          </div>
        </aside>
      </div>
    </section>
    <ProductFAQ faqs={faqs} title="Vragen over uw prijsindicatie" />
    </>
  );
}
